export default __webpack_public_path__ + "static/media/fab_logo_letter.5d8a99b1.svg";